import { type AuthToken } from '@reliance/types/models/Auth';
import { type Cdr } from '@reliance/types/models/Cdr';
import {
  type Visitation,
  type VisitationPending,
} from '@reliance/types/models/Visitation';
import { type PaginatedResponse } from '@reliance/types/responses/PaginatedResponse';
import { type ApiSuccessResponse, type ApiService } from '../types/ApiService';
import config from '../services/config';

export type CheckInVisitorResponse = Visitation;

export const visitation = (siteApi: ApiService, getToken: () => AuthToken) => ({
  recordingPreviewUrl: (id) => {
    return `${config.api.url}/visitation/recording/${id}/preview?token=${
      getToken().accessToken
    }`;
  },
  index: (params): Promise<VisitationPending[]> => {
    return siteApi.get('/visitation', { params });
  },
  post: (data: object): Promise<Visitation> => {
    return siteApi.post('/visitation', data);
  },
  search: (params?): Promise<PaginatedResponse<Cdr>> => {
    return siteApi.get('/visitation/search', { params });
  },
  delete: (id: number, note: string): Promise<ApiSuccessResponse<void>> => {
    return siteApi.delete(`/visitation/${id}`, { params: { note } });
  },
  checkInVisitor: (id: number): Promise<CheckInVisitorResponse> => {
    return siteApi.put(`/visitation/check-in-visitor/${id}`);
  },
  pdfUrl: (params = {}): string => {
    return siteApi.buildUrl('/visitation/search.pdf', {
      ...params,
      token: getToken().accessToken,
    });
  },
});
